import React from "react"
import styled from "styled-components"
import { Flex } from "../../layout/reusables"
import { Heading } from "../../styles/typography"
import {useSetRecoilState} from 'recoil';
import { currentAudioTrack } from "../../state/atoms"
export default function AudioPreviewItem({ item, name }) {

    const setAudio = useSetRecoilState(currentAudioTrack)

    const handlePlayAudio = () => {
        setAudio(item)
    }   
    

    return (
        <Container>
            <Flex onClick={() => handlePlayAudio()} style={{marginBottom: 20}} direction="row" align="center" justify="flex-start">
                <Soundbars src={require('../../images/sound-bars.svg')} />
                <Title>{item.title}</Title>
            </Flex>
        </Container>
    )
}

const Container = styled(Flex)`
    flex-direction: column;
    border-radius: 2px;
    /* padding: 15px; */
    
    transition: 0.2s ease;
    cursor: pointer;
    border: 1px solid #c6c6c6;
    border-radius: 4px;
    padding: 15px;
    transition: 0.2s ease;
    cursor: pointer;
    :hover {
        border: 1px solid black;
    }
`
const Soundbars = styled.img`
    width: 40px;
    margin-right: 20px;
`;
const Title = styled(Heading)`
    font-size: 20px;
    margin-bottom: 5px;
    font-weight: 400;
`